import * as React from 'react';
import moment, { MomentInput } from 'moment';

import { DATE_DISPLAY_FORMAT, DEFAULT_HOUR_MINUTE_DISPLAY } from 'pages/TrackAndTrace/config';

interface DateRangeProps {
  start: MomentInput;
  end?: MomentInput | null;
}

export const DateRange: React.FC<DateRangeProps> = (props) => {
  const start = moment(props.start);
  const end = props.end ? moment(props.end) : null;
  const startDateFormat = !end
    ? `${DATE_DISPLAY_FORMAT} ${DEFAULT_HOUR_MINUTE_DISPLAY} z`
    : `${DATE_DISPLAY_FORMAT} ${DEFAULT_HOUR_MINUTE_DISPLAY}`;

  const startDateTime = start.format(startDateFormat);
  if (!end) {
    return <h6>{startDateTime}</h6>;
  }

  const endTime = end.format(`${DEFAULT_HOUR_MINUTE_DISPLAY} z`);
  return (
    <h6>
      {startDateTime}-{endTime}
    </h6>
  );
};
DateRange.displayName = 'ContainerTable.DateRange';
